module.exports = __webpack_public_path__ + "img/tpv.4482f5ad.png";